import { z } from 'zod'
import { DeedmtgDataSchema } from './deedmtg'
import { AssessorDataSchema } from './assessor'
import { AddressMasterDataSchema } from './addressMaster'

export const FirstAmericanDataSchema = z.object({
  ...AddressMasterDataSchema.shape,
  assessor: AssessorDataSchema.optional().nullable(),
  deedmtgs: z.array(DeedmtgDataSchema).optional(),
})
export type FirstAmericanData = z.infer<typeof FirstAmericanDataSchema>

export const PermitStatusSchema = z.enum([
  'expired',
  'complete',
  'final',
  'filed',
  'plancheck',
  'triage',
  'issued',
  'revoked',
  'rejected',
  'canceled',
  'approved',
  'suspended',
  'withdrawn',
  'reinstated',
  'applied',
])
export type PermitStatus = z.infer<typeof PermitStatusSchema>

export const GeneralizedPermitStatusSchema = z.enum(['any', 'submitted', 'approved', 'completed', 'cancelled'])
export type GeneralizedPermitStatus = z.infer<typeof GeneralizedPermitStatusSchema>

const SUBMITTED_STATUSES: PermitStatus[] = ['applied', 'filed', 'triage', 'plancheck']
const APPROVED_STATUSES: PermitStatus[] = ['approved', 'issued', 'reinstated']
const COMPLETED_STATUSES: PermitStatus[] = ['complete', 'final']
const CANCELLED_STATUSES: PermitStatus[] = ['rejected', 'revoked', 'canceled', 'suspended', 'withdrawn', 'expired']

export const getPermitStatuses = (label: GeneralizedPermitStatus): PermitStatus[] | undefined => {
  switch (label) {
    case 'any':
      return
    case 'submitted':
      return SUBMITTED_STATUSES
    case 'approved':
      return APPROVED_STATUSES
    case 'completed':
      return COMPLETED_STATUSES
    case 'cancelled':
      return CANCELLED_STATUSES
  }
}

export const getGeneralizedPermitStatus = (
  status: PermitStatus
): Exclude<GeneralizedPermitStatus, 'any'> | undefined => {
  if (SUBMITTED_STATUSES.includes(status)) return 'submitted'
  if (APPROVED_STATUSES.includes(status)) return 'approved'
  if (COMPLETED_STATUSES.includes(status)) return 'completed'
  if (CANCELLED_STATUSES.includes(status)) return 'cancelled'
}
